export default function isProd() {
  return process.env.GATSBY_CONSTELLATION_ENVIRONMENT === 'PROD';
}
